import type { CanvasItem } from "@bedrock/domain";

export function hasSameCanvasLayout(left: CanvasItem, right: CanvasItem): boolean {
  return left.x === right.x &&
    left.y === right.y &&
    left.width === right.width &&
    left.height === right.height &&
    left.rotation === right.rotation &&
    left.zIndex === right.zIndex &&
    left.parentStackId === right.parentStackId;
}
